import { styled } from 'styled-components';
import { theme } from '../../templates/ui';

export const Title = styled.h3`
  color: ${theme.color.body.base};
`;
